import { format, parse } from 'date-fns';

const renderUtcDate = (
  date: string,
  inputFormat: string,
  outputFormat: string,
) => format(parse(date, inputFormat, new Date()), outputFormat);

export default renderUtcDate;
